import React, { useEffect, useState } from "react";
import { Mail, Paperclip, Link2, User, Loader2, Inbox } from "lucide-react";
import { api } from "../lib/api";

const MOD = {
  sopralluogo: { label: "Sopralluogo", bg: "#E3F2FD", fg: "#0D47A1" },
  installazione: { label: "Installazione", bg: "#E8F5E9", fg: "#1B5E20" },
  intervento: { label: "Intervento", bg: "#FFF3E0", fg: "#E65100" },
};
const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const Row = ({ e }) => {
  const m = MOD[e.module] || { label: e.module, bg: "#eee", fg: "#333" };
  return (
    <div className="card-shell p-4 space-y-2" data-testid={`email-log-${e.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded" style={{ background: m.bg, color: m.fg }}>{m.label}</span>
        <span className="text-sm font-semibold" data-testid={`email-log-date-${e.id}`}>{fmt(e.sent_at)}</span>
        <span className="text-xs inline-flex items-center gap-1 ml-auto" style={{ color: "var(--text-muted)" }}><User className="w-3.5 h-3.5" /> {e.sent_by_name}</span>
      </div>
      {e.subject && <div className="text-sm" style={{ color: "var(--text-muted)" }}>{e.subject}</div>}
      <div className="flex flex-wrap gap-1.5" data-testid={`email-log-to-${e.id}`}>
        {(e.to || []).map((t) => <span key={t} className="px-2 py-0.5 rounded-full text-xs font-semibold" style={{ background: "var(--surface-muted)" }}>{t}</span>)}
        {(e.cc || []).map((t) => <span key={`cc-${t}`} className="px-2 py-0.5 rounded-full text-xs" style={{ background: "#F1F5F9", color: "#475569" }}>CC {t}</span>)}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs" data-testid={`email-log-att-${e.id}`}>
        {(e.attachments || []).length > 0
          ? e.attachments.map((a) => <span key={a} className="inline-flex items-center gap-1"><Paperclip className="w-3.5 h-3.5" /> {a}</span>)
          : <span className="inline-flex items-center gap-1" style={{ color: "#B45309" }}><Paperclip className="w-3.5 h-3.5" /> {e.too_big ? "Allegati troppo grandi: inviato solo il link" : "Nessun allegato"}</span>}
        {e.link && <a href={e.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline" style={{ color: "var(--primary)" }}><Link2 className="w-3.5 h-3.5" /> Link condivisibile</a>}
      </div>
    </div>
  );
};

export const EmailStorico = ({ cid }) => {
  const [list, setList] = useState(null);
  useEffect(() => { api.get(`/clienti/${cid}/email-log`).then(({ data }) => setList(data)).catch(() => setList([])); }, [cid]);
  return (
    <div className="space-y-3" data-testid="tab-email-content">
      <div className="flex items-center gap-2">
        <Mail className="w-5 h-5" style={{ color: "var(--primary)" }} />
        <h2 className="text-lg font-bold" style={{ fontFamily: "Manrope" }}>Storico invii alla commessa</h2>
        {list && <span className="text-xs" style={{ color: "var(--text-muted)" }}>{list.length} invi{list.length === 1 ? "o" : "i"}</span>}
      </div>
      {!list ? <div className="text-sm flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento…</div>
        : list.length === 0 ? (
          <div className="card-shell p-8 text-center text-sm" style={{ color: "var(--text-muted)" }} data-testid="email-log-empty">
            <Inbox className="w-8 h-8 mx-auto mb-2" /> Nessuna email inviata alla commessa per questo cliente.
          </div>
        ) : list.map((e) => <Row key={e.id} e={e} />)}
    </div>
  );
};
